<div class="container-fluid border-1" style="max-width: 95%">
  <app-page-title
    title="Messages"
    [breadcrumbItems]="breadCrumbItems"></app-page-title>

  <div class="d-lg-flex">
    <div class="chat-leftsidebar">
      <div class="">
        <div class="search-box chat-search-box py-2">
          <div class="position-relative">
            <input
              [disabled]="rooms.length === 0"
              type="text"
              class="form-control"
              placeholder="Search for Resident or Family Names..."
              [(ngModel)]="searchText" />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>

        <div class="chat-leftsidebar-nav">
          <ul
            ngbNav
            #nav="ngbNav"
            [activeId]="1"
            class="nav-pills nav-justified">
            <li [ngbNavItem]="1">
              <ng-template ngbNavContent>
                <div>
                  <div class="d-flex align-items-center">
                    <span class="font-size-14 text-nowrap">Most Recent</span>
                    <select
                      #selRoomsType
                      class="border-0 form-select ms-auto fw-bold cursor-pointer"
                      [ngStyle]="{
                        width: '175px',
                        'background-color': 'rgba(255,255,255,0)',
                        'text-align-last': 'right'
                      }"
                      (change)="roomsFilter(selRoomsType.value)">
                      <option value="ALL">All Messages</option>
                      <option value="RESIDENT">Residents Messages</option>
                      <option style="padding-top: 20px" value="FAMILY">
                        Family Messages
                      </option>
                    </select>
                  </div>
                  <app-ngx-simplebar
                    *ngIf="rooms.length > 0 && isSorted; else emptyRooms"
                    style="position: relative; height: 462px"
                    class="f-out"
                    #scrollEle>
                    <div class="card">
                      <ul class="list-unstyled chat-list">
                        <li
                          class=""
                          *ngFor="
                            let data of roomsFiltered
                              | appFilter : searchText
                              | slice : 0 : (page - 1) * pageSize + pageSize
                          ">
                          <a
                            [style]="
                              data.roomId === currentRoomId
                                ? 'background-color: #5edbc82c'
                                : ''
                            "
                            href="javascript: void(0);"
                            (click)="chatUsername(data)">
                            <div class="media" style="display: flex !important">
                              <div class="flex-shrink-0 align-self-center me-3">
                                <img
                                  [src]="data.users[0].avatar"
                                  class="rounded-circle avatar-xs" />
                              </div>
                              <div
                                class="media-body overflow-hidden"
                                style="flex-grow: 1; max-width: 210px">
                                <h5
                                  class="text-truncate font-size-16 mb-1 fw-bolder text-dark">
                                  {{ data.roomName }}
                                </h5>
                                <div
                                  *ngIf="data.relationship"
                                  class="mt-n1 font-size-12">
                                  {{ data.relationship }} of
                                  <span class="text-primary"
                                    ><b>{{ data.residentName }}</b></span
                                  >
                                </div>
                                <div
                                  class="mt-2"
                                  style="display: flex !important">
                                  <p
                                    class="text-truncate mb-0"
                                    [style]="
                                      data.lastMessage.content === ''
                                        ? 'color:#07B59A'
                                        : ''
                                    ">
                                    {{
                                      data.lastMessage.content === ''
                                        ? 'Image'
                                        : data.lastMessage.content
                                    }}
                                  </p>
                                  <i
                                    *ngIf="data.lastMessage.content === ''"
                                    class="bx bx-image-alt"
                                    style="
                                      color: #07b59a;
                                      margin-left: 3.3px;
                                      margin-top: 3.3px;
                                    "></i>
                                </div>
                              </div>
                              <div class="row text-end ms-auto">
                                <div class="col-12">
                                  <span
                                    *ngIf="
                                      data.unreadCount > 0 &&
                                      data.roomId !== currentRoomId
                                    "
                                    class="badge rounded-pill"
                                    style="
                                      background-color: #07b59a;
                                      height: 15.5px;
                                      margin-left: 4px;
                                    ">
                                    {{ data.unreadCount }}
                                  </span>
                                </div>
                                <div class="col-12 text-nowrap font-size-11">
                                  {{ checkTime(data.lastMessage.timestamp) }}
                                </div>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div
                      class="d-flex justify-content-center pb-5"
                      *ngIf="
                        page * this.pageSize <
                        (rooms | appFilter : searchText).length
                      ">
                      <a
                        class="text-primary cursor-pointer"
                        (click)="onPageChange()"
                        >Load More ...</a
                      >
                    </div>
                  </app-ngx-simplebar>
                  <ng-template #emptyRooms>
                    <div class="p-2">
                      <ngb-alert type="warning">
                        This community doesn’t have any rooms!
                      </ngb-alert>
                    </div>
                  </ng-template>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="my-4"></div>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-xl-9 user-chat ms-lg-4">
      <div class="card">
        <div class="p-4 border-bottom">
          <div class="row">
            <div class="d-flex flex-wrap col-9">
              <div
                *ngIf="currentRoomName !== ''"
                class="flex-shrink-0 align-self-center me-3"
                style="margin-top: -5px">
                <img
                  (click)="lightboxImage(currentRoomAvatar, currentRoomName)"
                  [src]="currentRoomAvatar"
                  class="avatar-xs rounded-circle"
                  alt="" />
              </div>
              <h5 class="font-size-18 mb-1">
                {{
                  !residentName
                    ? 'Select a room'
                    : currentRoomRelationship
                    ? currentRoomName
                    : null
                }}
                <span
                  class="fw-normal font-size-14 ms-3"
                  *ngIf="currentRoomRelationship"
                  >{{ currentRoomRelationship + ' of ' }}</span
                >
                <a
                  *ngIf="residentCurrentId"
                  [routerLink]="[
                    '/communities',
                    currentCommunityId,
                    'residents',
                    residentCurrentId
                  ]"
                  target="_blank">
                  {{ residentName }}
                  <i class="bx bx-chevron-right align-middle"></i>
                </a>
              </h5>
            </div>
            <div class="col-3 text-end" *ngIf="residentName">
              <button class="btn btn-soft-primary" (click)="onDownloadCSV()">
                <i class="bx bx-download"></i>
                Download Message Thread
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="chat-conversation p-3" style="height: 470px">
            <app-ngx-simplebar style="height: 470px" #scrollRef>
              <h4
                *ngIf="currentRoomId === ''"
                style="text-align: center; color: gray">
                No messages. Select a room.
              </h4>
              <ul class="list-unstyled" *ngIf="currentRoomId !== ''">
                <div *ngFor="let dateMessage of sortedMessages">
                  <li>
                    <div class="chat-day-title">
                      <span class="title">{{ dateMessage.date }}</span>
                    </div>
                  </li>
                  <li
                    *ngFor="
                      let data of dateMessage.Belongmessages;
                      let i = index
                    "
                    [ngClass]="{
                      right: data.senderId === user?.oldUserId,
                      systemMessage: data.system
                    }">
                    <div
                      *ngIf="
                        !returnImage(data) ||
                        !(
                          compareImage(i, returnImage(data)) &&
                          updateLastImage(returnImage(data))
                        )
                      "
                      class="conversation-list ms-4"
                      [ngClass]="{
                        systemXlMargin: data.system,
                        systemSmMargin: data.system,
                        systemMdMargin: data.system,
                        systemMiniMargin: data.system
                      }"
                      [style]="data.system ? 'float: none !important' : ''">
                      <div
                        class="dropdown"
                        [ngClass]="{
                          'me-3': data.senderId !== user?.oldUserId
                        }"
                        ngbDropdown
                        *ngIf="!data.system">
                        <a
                          class="dropdown-toggle"
                          href="javascript: void(0);"
                          role="button"
                          ngbDropdownToggle>
                          <i class="bx bx-dots-vertical-rounded"></i>
                        </a>
                        <div class="dropdown-menu" ngbDropdownMenu>
                          <a
                            class="dropdown-item"
                            (click)="copyAction(data.content, data.username)"
                            >Copy</a
                          >
                          <a
                            *ngIf="data.senderId === user?.oldUserId"
                            class="dropdown-item"
                            (click)="deleteMessage(data, currentRoomId)"
                            >Delete</a
                          >
                        </div>
                      </div>
                      <div class="ctext-wrap me-4">
                        <div class="conversation-name">{{ data.username }}</div>
                        <img
                          style="
                            margin: auto;
                            display: block;
                            width: 250px;
                            height: 180px;
                            border-radius: 4%;
                          "
                          (click)="lightboxImage(returnImage(data))"
                          *ngIf="showImageOrMessage(data)"
                          src="{{ returnImage(data) }}" />
                        <p *ngIf="!showImageOrMessage(data)">
                          {{ parseMessage(data.content, data.username) }}
                        </p>
                        <p class="chat-time mb-0" *ngIf="!data.system">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ data.timestamp }}
                        </p>
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </app-ngx-simplebar>
          </div>
          <div class="p-3 chat-input-section">
            <form (ngSubmit)="sendMessage()" [formGroup]="formData" class="row">
              <div class="col">
                <div class="position-relative" *ngIf="currentRoomId !== ''">
                  <input
                    [hidden]="!showImagePreview()"
                    type="text"
                    [minlength]="!isEmoji ? 5 : 1"
                    class="form-control chat-input"
                    placeholder="Enter Message..."
                    formControlName="message"
                    [ngClass]="{
                      'is-invalid': chatSubmit && form.message.errors
                    }" />
                  <img
                    [hidden]="showImagePreview()"
                    id="img_preview"
                    src=""
                    style="width: 180px; height: 115px; border-radius: 4%" />
                  <span
                    (click)="unselectImage()"
                    [hidden]="showImagePreview()"
                    class="badge rounded-pill"
                    style="background-color: lightgray; position: absolute">
                    x
                  </span>
                  <div
                    *ngIf="chatSubmit && form.message.errors"
                    class="invalid-feedback">
                    <span *ngIf="form.message.errors.required"
                      >This value is required.</span
                    >
                  </div>
                  <div
                    [style]="!showImagePreview() ? 'right: 0px;top: 16%;' : ''"
                    class="chat-input-links">
                    <ul class="list-inline mb-0">
                      <li
                        [hidden]="!showImagePreview()"
                        class="list-inline-item"
                        (click)="isEmojiPickerVisible = !isEmojiPickerVisible">
                        <a
                          data-toggle="tooltip"
                          placement="top"
                          ngbTooltip="Emoji"
                          ><i class="mdi mdi-emoticon-happy-outline"></i
                        ></a>
                      </li>
                      <emoji-mart
                        class="emoji-mart"
                        *ngIf="isEmojiPickerVisible"
                        (emojiSelect)="addEmoji($event)"
                        title="Choose your emoji"></emoji-mart>
                      <li class="list-inline-item">
                        <a
                          (click)="setFileChat()"
                          data-toggle="tooltip"
                          placement="top"
                          ngbTooltip="Images"
                          ><i class="mdi mdi-file-image-outline"></i
                        ></a>
                        <input
                          hidden
                          type="file"
                          accept="image/png, image/jpeg"
                          id="fileMessage"
                          (change)="handleFileInput($event.target)" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <button
                  [disabled]="sendLoading"
                  *ngIf="currentRoomId !== ''"
                  type="submit"
                  class="btn btn-primary btn-rounded chat-send w-md">
                  <span class="d-none d-sm-inline-block me-2">
                    <div
                      *ngIf="sendLoading"
                      class="spinner-border text-light border-2"
                      [ngStyle]="{ height: '15px', width: '15px' }"
                      role="status"></div>
                    Send
                  </span>
                  <i class="mdi mdi-send"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end row -->
</div>
